'use client';

import { BotIcon } from '@terra/ui-icons';

export type ExecutionNeoIconProps = {
  size?: number;
};
export function ExecutionNeoIcon({ size = 16 }: ExecutionNeoIconProps) {
  return <BotIcon size={size} aria-hidden />;
}
